var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ml-4",attrs:{"items":_vm.semesters(),"chips":"","deletable-chips":"","item-text":"value","item-value":"key","menu-props":"auto","multiple":"","placeholder":"Wszystkie semestry","single-line":""},model:{value:(_vm.semesterSelected),callback:function ($$v) {_vm.semesterSelected=$$v},expression:"semesterSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }